<template>
  <div class="project">
    <router-link :to="`/risk/${project.id}`" class="project-link">
      <div class="project-title-group">
        <subtitle class="project-subtitle">{{ project.name }}</subtitle>
        <MainBadge :content="projectStatusesValues[project.status]" :variant="projectStatuses[project.status]" />
      </div>

      <p class="project-info">{{ city }}, {{ new Date(project.created_at * 1000) | moment("DD.MM.YYYY") }}</p>
    </router-link>
    <button @click="isContextMenuOpen = !isContextMenuOpen" class="project-menu-button" />
    <div v-if="isContextMenuOpen" class="project-context-menu">
      <button @click="closeContextMenu()" class="project-context-menu-close-button" />
      <ul>
        <li>
          <button @click="dublicate(project.id)" class="project-context-menu-button">Создать копию</button>
        </li>
        <li>
          <button
            @click="
              closeContextMenu();
              openEditProjectModal(project);
            "
            class="project-context-menu-button"
          >
            Изменить
          </button>
        </li>
        <li>
          <button
            @click="
              openConfirmModal(project.id);
              closeContextMenu();
            "
            class="project-context-menu-button project-context-menu-button_danger"
          >
            Удалить
          </button>
        </li>
      </ul>
    </div>
    <div @click="closeContextMenu" v-if="isContextMenuOpen" class="project-context-menu-overlay" />
    <ConfirmModal
      :id="project.id"
      title="Удаление"
      content="Вы действительно хотите удалить данный проект?"
      @onSubmitClick="remove(project.id)"
      :loading="isDeleteLoading"
    />
  </div>
</template>

<script>
import Subtitle from "./ui/Subtitle.vue";
import MainBadge from "./ui/MainBadge.vue";
import ConfirmModal from "./modals/ConfirmModal.vue";
import { PROJECT_STATUSES_VALUES } from "../constants/constants";
import { PROJECT_STATUSES } from "../constants/constants";

export default {
  props: {
    project: {
      type: Object,
    },
    openEditProjectModal: Function,
  },
  data() {
    return {
      projectStatuses: PROJECT_STATUSES,
      projectStatusesValues: PROJECT_STATUSES_VALUES,
      isContextMenuOpen: false,
      city: "",
      isDeleteLoading: false,
    };
  },
  components: { Subtitle, MainBadge, ConfirmModal },
  methods: {
    dublicate(projId) {
      this.$http
        .get("projects/dublicate", {
          params: {
            proj_id: projId,
          },
        })
        .then(() => {
          this.$emit("projectsUpdated");
          this.closeContextMenu();
        })
        .catch((err) => {
          alert(err);
        });
    },

    getCity(cityId) {
      if (cityId) {
        this.$http.get(`risk/cities/get?id=${cityId}`).then((response) => {
          this.city = response.data.CITY;
        });
      }
    },

    remove(projId) {
      this.isDeleteLoading = true;
      this.$http
        .get("projects/remove", {
          params: {
            proj_id: projId,
          },
        })
        .then(() => {
          this.$emit("projectsUpdated");
          this.closeContextMenu();
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          this.isDeleteLoading = false;
        });
    },

    openConfirmModal(id) {
      this.$bvModal.show(String(id));
    },

    closeContextMenu() {
      this.isContextMenuOpen = false;
    },
  },
  mounted() {
    this.getCity(this.project.city);
  },
};
</script>

<style scoped>
.project {
  position: relative;
  border-bottom: 1px solid #d5d5df;
  transition: border 0.15s ease-out;
}
.project-link {
  display: block;
  padding-right: 40px;
  padding-top: 24px;
  padding-bottom: 8px;
  position: relative;
}

.project:last-of-type {
  border-bottom: none;
}
.project:hover {
  border-bottom: 1px solid var(--secondary-hover-color);
}
.project-title-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}
.project-subtitle {
  max-width: 75%;
}
.project-info {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: var(--grey-3-color);
  margin-bottom: 0;
}
.project-menu-button {
  position: absolute;
  top: 45%;
  right: 0;
  width: 20px;
  height: 20px;
  background-color: transparent;
  background-image: url("../files/project-menu-icon.svg");
  background-size: cover;
  background-repeat: no-repeat;
  border: none;
  outline: none;
  cursor: pointer;
  transition: opacity 0.15s ease-out;
}
.project-menu-button:hover {
  opacity: 0.7;
}
.project-context-menu {
  position: absolute;
  right: 0;
  top: 35px;
  width: 129px;
  height: 132px;
  background: var(--white-color);
  box-shadow: 0px 4px 8px rgba(0, 46, 166, 0.15);
  border-radius: 4px;
  /* z-index странно выглядит потому что приходится перебивать стили библиотек :) */
  z-index: 1055;
}
.project-context-menu-button {
  display: flex;
  align-items: center;
  border: none;
  padding: 0 12px;
  background-color: transparent;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  color: var(--black-color);
  width: 100%;
  height: 36px;
}

.project-context-menu-button:hover {
  background-color: #20a39e26;
}
.project-context-menu-button_danger {
  color: var(--error-color);
}
.project-context-menu-close-button {
  width: 16px;
  height: 16px;
  position: absolute;
  right: 0;
  top: -20px;
  background-color: transparent;
  border: none;
  outline: none;
}
.project-context-menu-overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1050;
}
</style>
